// @flow
import React from "react";
import styled from "styled-components";
import freeIcon from "./images/free@3x.png";
import inviteIcon from "./images/invite@3x.png";
import newIcon from "./images/new@3x.png";
import newIronIcon from "./images/new-iron@3x.png";
import demo2xIcon from "./images/demo2xIcon.png";
import { rtl } from "../common/styled-mixins";

const View = styled.i`
  position: absolute;
  top: 0;
  ${rtl("right", 0)};
  ${rtl("transform", "none", "rotate(-90deg)")};
  width: ${({ width }) => (width ? width : "43px")};
  height: ${({ height }) => (height ? height : "42px")};
  background-repeat: no-repeat;
  background-image: url(${props => props.bgIcon});
  background-position: center;
  background-size: contain;
`;

type Props = {
  type: "free" | "pay",
  isNew: boolean,
  limited: 0 | 1,
  active: boolean
};

export default function Sticker({
  type = "pay",
  active = false,
  limited = false,
  isNew = false,
  subtype
}: Props) {
  if (subtype === "demo") {
    return <View bgIcon={demo2xIcon} width="42px" height="43px" />;
  }
  if (limited) {
    return <View bgIcon={inviteIcon} />;
  }

  if (type === "free" || (isNew === true && active === false)) {
    switch (type) {
      case "free":
        return <View bgIcon={freeIcon} />;
      default:
        return process.env.REACT_APP_DEPLOY_TARGET === "irontrade" ? (
          <View bgIcon={newIronIcon} />
        ) : (
          <View bgIcon={newIcon} />
        );
    }
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/components/Tournaments/Sticker.js